// extracted by mini-css-extract-plugin
module.exports = {"preview":"VehiclePhotosSection_preview__HQN9s","thumbnailBadge":"VehiclePhotosSection_thumbnailBadge__aRwFg"};